import React from "react";
import Drawer from "../PopUps/Drawer";

export default function Avatar() {
  return (
    <div className="w-50 flex h-full justify-center items-center gap-2 rounded-full border-gray-300 py-1 px-2 md:border">
      <Drawer />
    </div>
  );
}
